<div class="identifier-first-signin registration-popup">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h2 class="mg-btm-32">Sign up with email</h2>
    </div>
  </div>

  <ng-container *ngIf="step === 'email'">
    <app-alert [alertService]="alertService"></app-alert>
    <form [formGroup]="emailForm" (ngSubmit)="onEmailContinue()" novalidate>
      <div class="row mg-top-16">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div
            class="form-group"
            [ngClass]="{ 'ng-invalid': emailForm.get('email')?.invalid && emailForm.get('email')?.touched }"
          >
            <label for="signup-email">Email Address*</label>
            <input
              type="text"
              class="form-control"
              id="signup-email"
              formControlName="email"
              placeholder="Enter your email"
            />
            <app-validation-message [control]="emailForm.controls.email" class="form-error"></app-validation-message>
          </div>
        </div>
      </div>
      <div class="form-error valid-error" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="row mg-top-24">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <button type="submit" class="btn wb-btn-default center-block" [disabled]="loading || disableContinue">
            Continue
            <span *ngIf="loading" class="loading-animation"></span>
          </button>
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col-md-12 text-center mg-top-18">
        <span role="button" (click)="openSignInModal()" class="forget-sign-link already-link">Already have an account? Sign in</span>
      </div>
      <div class="col-md-12 text-center mg-top-12">
        <span role="button" (click)="openRegisterModal()" class="forget-sign-link already-link">Sign up with password instead</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 'otpConfirm'">
    <div *ngIf="otpRateLimitBanner" class="row">
      <div class="col-lg-12">
        <div class="alert alert-danger ciam-v6-rate-banner" role="alert">
          <span>{{ otpRateLimitBanner }}</span>
          <a *ngIf="otpShowContactUs" href="/contact-us" class="ciam-v6-inline-help">Contact us</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="mg-btm-9 mg-top-12">We'll send a code</h2>
        <span class="hint-text">We'll send a one-time code to {{ maskedIdentifier }}</span>
      </div>
    </div>
    <div class="form-error valid-error" *ngIf="errorMessage">{{ errorMessage }}</div>
    <div class="row mg-top-24">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <button type="button" class="btn wb-btn-default center-block" (click)="onOtpSendCode()" [disabled]="loading || otpContinueDisabled">
          {{ loading ? 'Sending...' : 'Send Code' }}
        </button>
      </div>
    </div>
    <div class="text-center mg-top-18">
      <span role="button" (click)="onBack()" class="forget-sign-link"> Back </span>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 'otpVerify'">
    <div *ngIf="otpRateLimitBanner" class="row">
      <div class="col-lg-12">
        <div class="alert alert-danger ciam-v6-rate-banner" role="alert">
          <span>{{ otpRateLimitBanner }}</span>
          <a *ngIf="otpShowContactUs" href="/contact-us" class="ciam-v6-inline-help">Contact us</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="mg-btm-9 mg-top-12">Enter code</h2>
        <span class="hint-text">Enter the code we sent to {{ maskedIdentifier }}.</span>
      </div>
    </div>
    <form [formGroup]="otpForm" (ngSubmit)="onOtpVerify()" novalidate>
      <div class="row mg-top-16">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div
            class="form-group"
            [ngClass]="{ 'ng-invalid': otpForm.get('otpCode')?.invalid && otpForm.get('otpCode')?.touched }"
          >
            <label for="signup-otpCode">Code</label>
            <input
              type="text"
              class="form-control"
              id="signup-otpCode"
              formControlName="otpCode"
              autocomplete="one-time-code"
              placeholder="Enter 6-digit code"
              maxlength="6"
            />
            <app-validation-message [control]="otpForm.controls.otpCode" class="form-error"></app-validation-message>
          </div>
        </div>
      </div>
      <div class="form-error valid-error" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="row mg-top-24">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <button type="submit" class="btn wb-btn-default center-block" [disabled]="loading || otpForm.invalid || otpContinueDisabled">
            {{ loading ? 'Verifying...' : 'Verify' }}
          </button>
        </div>
      </div>
      <div class="text-center mg-top-18">
        <span role="button" (click)="onResendOtp()" class="forget-sign-link mg-right-8" [class.disabled]="loading || otpResendDisabled">Resend code</span>
        <span role="button" (click)="onBack()" class="forget-sign-link"> Back </span>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="step === 'social'">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="mg-btm-9 mg-top-12">Continue with your account</h2>
        <span class="hint-text" *ngIf="socialProviders?.length">This email is linked to </span>
        <span class="hint-text" *ngFor="let p of socialProviders; let i = index">{{ i > 0 ? ', ' : '' }}{{ getProviderLabel(p) }}</span>
        <span class="hint-text" *ngIf="socialProviders?.length">. Sign in with that provider to continue.</span>
        <span class="hint-text" *ngIf="!socialProviders?.length">An account with this email already exists. Sign in with a social provider.</span>
      </div>
    </div>
    <div class="row mg-top-24">
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center" *ngIf="!socialProviders?.length || hasProvider('google')">
        <button role="button" class="btn social-google" (click)="onSocialClick('google')" [disabled]="loading"></button>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center" *ngIf="!socialProviders?.length || hasProvider('facebook')">
        <button role="button" class="btn social-fb" (click)="onSocialClick('facebook')" [disabled]="loading"></button>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center" *ngIf="!socialProviders?.length || hasProvider('apple')">
        <button role="button" class="btn social-apple" (click)="onSocialClick('apple')" [disabled]="loading"></button>
      </div>
    </div>
    <div class="text-center mg-top-18">
      <span role="button" (click)="openSignInModal()" class="forget-sign-link mg-right-8">Other sign-in options</span>
      <span role="button" (click)="onBack()" class="forget-sign-link"> Back </span>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 'signInInstead'">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="mg-btm-9 mg-top-12">Account already exists</h2>
        <span class="hint-text">{{ blockedMessage }}</span>
      </div>
    </div>
    <div class="row mg-top-24">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <button type="button" class="btn wb-btn-default center-block" (click)="openSignInModal()">Go to sign in</button>
      </div>
    </div>
    <div class="text-center mg-top-18">
      <span role="button" (click)="onBack()" class="forget-sign-link"> Back </span>
    </div>
  </ng-container>
</div>
